import { transactionsActions } from "@components/features/transactions/transactions.slice";
import CheckoutForm from "@components/molecules/checkout-form";
import GameDetailsCardMini from "@components/molecules/game-details-card-mini";
import CloseIcon from "@mui/icons-material/Close";
import Box from "@mui/material/Box";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import Grid from "@mui/material/Grid";
import IconButton from "@mui/material/IconButton";
import Slide from "@mui/material/Slide";
import Toolbar from "@mui/material/Toolbar";
import { TransitionProps } from "@mui/material/transitions";
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import dayjs from "dayjs";
import React from "react";
import { useEffect, useState } from "react";
import { ConnectedProps, connect } from "react-redux";
import { useNavigate } from "react-router-dom";

import "../../../App.css";
import {
  ActionWrapper,
  Content,
  DialogTitle,
  FinePrint,
  Typography,
} from "./stripeModal.styled";

type ReduxProps = ConnectedProps<typeof connector>;

const { REACT_APP_STRIPE_KEY } = process.env;

const stripePromise = loadStripe(REACT_APP_STRIPE_KEY!);

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement<any, any>;
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="up" ref={ref} {...props} />;
});

const StripePaymentModal = ({
  handleClose,
  isOpen,
  createPaymentIntent,
  game_details,
}: ReduxProps & {
  isOpen: boolean;
  game_details: any;
  handleClose: () => void;
}) => {
  const navigate = useNavigate();
  const [clientSecret, setClientSecret] = useState("");

  const postPaymentIntent = async () => {
    const body = {
      game_id: game_details.selectedGame!,
    };
    const response = await createPaymentIntent(body);
    setClientSecret(response?.payload?.client_secret);
  };

  useEffect(() => {
    postPaymentIntent();
  }, []);

  const appearance = {
    theme: "stripe",
  };
  const options: any = {
    clientSecret,
    appearance,
  };

  const userDeclaration = `This game is organised by a user on rkbt.ai.
   Before proceeding with your payment for this game, ensure you trust the organizer
   or the person who invited you.`;

  const getDate = (date: string) => {
    return new Date(date).toISOString().slice(0, 10);
  };

  const getTime = (d: string) => {
    const date = new Date(d).toISOString();
    const timeObject = dayjs(date);
    const formattedTime = timeObject.format("ddd, MMM YYYY, hh:mm A");
    return formattedTime;
  };

  return (
    <>
      <Dialog
        fullScreen
        open={isOpen}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        maxWidth={"mobile"}
        aria-describedby="alert-dialog-slide-description"
      >
        <Toolbar>
          <IconButton
            aria-label="close"
            onClick={handleClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </Toolbar>
        <DialogContent>
          <GameDetailsCardMini
            date={game_details.date}
            fee={game_details.fee}
            location={game_details.location}
            title={game_details.title}
            addressCoordinate={game_details.addressCoordinate}
            startDate={game_details.startDate}
            currency={game_details.currency}
          />
          <div className=".AppWrapper">
            {clientSecret && (
              <Elements options={options} stripe={stripePromise}>
                <CheckoutForm />
              </Elements>
            )}
          </div>
          <Content>
            <FinePrint>{userDeclaration}</FinePrint>
          </Content>
        </DialogContent>
      </Dialog>
    </>
  );
};

const mapDispatchToProps = {
  createPaymentIntent: transactionsActions.createPaymentIntent,
};

const connector = connect(undefined, mapDispatchToProps);
const StripePaymentModalRedux = connector(StripePaymentModal);

export { StripePaymentModalRedux as StripePaymentModal };
